/* JoyForm keychain live preview.
   Geometry mirrors name_keychain.scad: strokeText with lineWidth = 2 x offset
   is the canvas equivalent of OpenSCAD's offset(r=).
   Palette = Patron filament stock, sampled from patron-3d.com print photos,
   plus Lavender = Bambu Lab PLA Translucent Lavender (13711)
   (duplicated in keychain-personalizer.liquid and color-model-stage.liquid).
   Marble colours are drawn as a base fill plus deterministic speckles,
   composited per layer so flecks stay inside their own part.
   Products whose personalizer root has data-jf-preview="false" (tag
   jf:no-preview) or has no name field (tag jf:no-name) keep the colour
   swatches working but never mount the keychain render over their gallery.
   data-jf-layers (tag jf:nametag-preview) maps the initial, outline and name
   layers onto a product's own colour-part slots, e.g. "c1,c2,c3".
   data-jf-accent (tag jf:bow-case) names the slot that colours the 3D
   accessories (bow lipstick case and charm) shown beside the tag.
   data-jf-3d carries the asset URLs for jf-nametag-3d.js; when WebGL and the
   module load, the live 3D tag replaces the 2D canvas, which otherwise stays
   as the fallback (and for name fonts the 3D view does not have). */
(function () {
  var P = { Base_Height: 45, Base_Rim_Width: 2.0, Name_Total_Offset: 2.0,
            Name_Scale: 1.0, Rotation_Angle: 10, Vertical_Adj: -2,
            Horizontal_Adj: 0, Letter_Spacing: 1.05 };
  var PX = 11;
  var NAME_SIZE = (P.Base_Height / 3.5) * P.Name_Scale;

  var COLORS = {
    "Green":        { hex: "#04AD73" },
    "Baby Pink":    { hex: "#FDBCDD" },
    "Hot Pink":     { hex: "#F96B98" },
    "Brown":        { hex: "#59302C" },
    "Black":        { hex: "#1B1C28" },
    "Blue":         { hex: "#07298C" },
    "Baby Blue":    { hex: "#03BBFD" },
    "Lavender":     { hex: "#B8ACD6" },
    "Beige":        { hex: "#FCDBB3" },
    "Marble White": { hex: "#D3D5E3", fleck: "#62595B" },
    "Marble Brown": { hex: "#D1B380", fleck: "#5D4017" }
  };
  var DEFAULTS = { base: "Baby Pink", outline: "Marble White", core: "Hot Pink" };

  var GALLERY_SELECTORS = [
    "media-gallery",
    ".product-media-container",
    "[class*='product-media-gallery']",
    ".product-media",
    "slideshow-component"
  ];

  function findGallery() {
    for (var i = 0; i < GALLERY_SELECTORS.length; i++) {
      var el = document.querySelector(GALLERY_SELECTORS[i]);
      if (el && el.offsetParent !== null) return el;
    }
    return null;
  }

  function buildStage(root) {
    var stage = document.createElement("div");
    stage.className = "jf-overlay";
    stage.innerHTML =
      '<canvas width="720" height="720" role="img" aria-label="Live preview of your keychain"></canvas>' +
      '<p class="jf-cap"></p>';

    var host = findGallery();
    if (host) {
      if (window.getComputedStyle(host).position === "static") host.style.position = "relative";
      host.appendChild(stage);
      stage.classList.add("jf-overlay--pinned");
      var toggle = document.createElement("button");
      toggle.type = "button";
      toggle.className = "jf-toggle";
      toggle.hidden = true;
      toggle.textContent = "Show photos";
      host.appendChild(toggle);
      stage.jfToggle = toggle;
    } else {
      var fb = root.querySelector("[data-jf-fallback]");
      (fb || root).appendChild(stage);
      stage.classList.add("jf-overlay--inline");
    }
    return stage;
  }

  /* Shopify rewrites dynamic imports in classic theme scripts like this one,
     so the module is loaded by a small inline <script type="module"> that
     hands it back through a one-off callback. */
  var nametag3dReady = null;
  function loadNametag3D(url) {
    nametag3dReady = nametag3dReady || new Promise(function (resolve, reject) {
      window.__jfNametag3D = function (err, mod) {
        delete window.__jfNametag3D;
        if (err || !mod) reject(err || new Error("jf-nametag-3d did not load"));
        else resolve(mod);
      };
      var script = document.createElement("script");
      script.type = "module";
      script.textContent = "imp" + "ort(" + JSON.stringify(url) + ")" +
        ".then(function (m) { window.__jfNametag3D(null, m); })" +
        ".catch(function (e) { window.__jfNametag3D(e); });";
      document.head.appendChild(script);
    });
    return nametag3dReady;
  }

  function init(root) {
    if (root.dataset.jfReady) return;
    root.dataset.jfReady = "1";

    var nameIn = root.querySelector("[data-jf-name]");
    var fontIn = root.querySelector("[data-jf-font]");

    /* No name field means no keychain render; the swatches below still work. */
    var previewOn = !!nameIn && root.dataset.jfPreview !== "false";

    /* Which colour-part slot drives each preview layer. */
    var layerSlots = (root.dataset.jfLayers || "base,outline,core").split(",");
    var LAYER_SLOT = { base: layerSlots[0], outline: layerSlots[1], core: layerSlots[2] };
    var accentSlot = root.getAttribute("data-jf-accent");

    /* Swatches always write their hidden inputs so the colours reach the order. */
    var slots = {};
    root.querySelectorAll("[data-jf-slot]").forEach(function (group) {
      var slot = group.dataset.jfSlot;
      var hidden = root.querySelector('[data-jf-value="' + slot + '"]');
      slots[slot] = hidden;
      group.querySelectorAll(".jf-swatch").forEach(function (btn) {
        btn.addEventListener("click", function () {
          hidden.value = btn.dataset.color;
          group.querySelectorAll(".jf-swatch").forEach(function (b) {
            b.setAttribute("aria-pressed", String(b === btn));
          });
          if (previewOn) draw();
        });
      });
    });

    /* Non-keychain products: fields only, no keychain render over the photos. */
    if (!previewOn) return;

    var stage = buildStage(root);
    var cv = stage.querySelector("canvas");
    var cap = stage.querySelector(".jf-cap");
    var toggle = stage.jfToggle;
    var ctx = cv.getContext("2d");
    var userHid = false;

    /* Live 3D tag over the same stage; the 2D canvas keeps drawing underneath
       so it can take over if 3D is unavailable for the chosen font. */
    var view3d = null, pending3d = 0;
    var cfg3d = null;
    /* getAttribute: "data-jf-3d" has no dataset name because a digit follows the dash. */
    var raw3d = root.getAttribute("data-jf-3d");
    try { cfg3d = raw3d ? JSON.parse(raw3d) : null; } catch (e) { cfg3d = null; }
    if (cfg3d && window.WebGLRenderingContext) {
      var box3d = document.createElement("div");
      box3d.className = "jf-3d";
      stage.insertBefore(box3d, cv);
      loadNametag3D(cfg3d.module)
        .then(function (api) { return api.createNametag3D(box3d, cfg3d); })
        .then(function (view) { view3d = view; draw(); })
        .catch(function (err) {
          console.warn("[jf-nametag-3d]", err);
          box3d.remove();
        });
    }

    function update3d(state) {
      if (!view3d) return;
      clearTimeout(pending3d);
      pending3d = setTimeout(function () {
        view3d.update(state).then(function (ok) {
          stage.classList.toggle("jf-overlay--3d", !!ok);
        }).catch(function (err) {
          console.warn("[jf-nametag-3d]", err);
          stage.classList.remove("jf-overlay--3d");
        });
      }, 60);
    }

    if (toggle) {
      toggle.addEventListener("click", function () {
        userHid = !userHid;
        toggle.textContent = userHid ? "Show my design" : "Show photos";
        stage.classList.toggle("is-on", !userHid);
      });
    }

    function spec(layer) {
      var hidden = slots[LAYER_SLOT[layer]];
      var name = (hidden && hidden.value) || DEFAULTS[layer];
      return { name: name, def: COLORS[name] || COLORS[DEFAULTS[layer]] };
    }

    /* Deterministic speckle so the pattern doesn't crawl between redraws. */
    function speckle(o, color, seed) {
      var s = seed || 1;
      function rnd() { s = (s * 1664525 + 1013904223) % 4294967296; return s / 4294967296; }
      o.save();
      o.globalCompositeOperation = "source-atop";
      o.fillStyle = color;
      for (var i = 0; i < 900; i++) {
        var x = rnd() * cv.width, y = rnd() * cv.height, r = 0.8 + rnd() * 2.0;
        o.beginPath(); o.arc(x, y, r, 0, Math.PI * 2); o.fill();
      }
      o.restore();
    }

    /* Each part is painted on its own surface so marble flecks stay inside it. */
    function layer(paint, def, seed) {
      var off = document.createElement("canvas");
      off.width = cv.width; off.height = cv.height;
      var o = off.getContext("2d");
      paint(o, def.hex);
      if (def.fleck) speckle(o, def.fleck, seed);
      ctx.drawImage(off, 0, 0);
    }

    function draw() {
      var w = cv.width, h = cv.height;
      ctx.clearRect(0, 0, w, h);
      var nm = (nameIn.value || "").trim();

      if (!nm) {
        stage.classList.remove("is-on");
        if (toggle) { toggle.hidden = true; userHid = false; toggle.textContent = "Show photos"; }
        cap.textContent = "";
        return;
      }
      if (toggle) toggle.hidden = false;
      if (!userHid) stage.classList.add("is-on");

      var cx = w / 2, cy = h / 2 + 14;
      var initial = nm[0].toUpperCase();
      var b = spec("base"), ou = spec("outline"), co = spec("core");
      var font = (fontIn && fontIn.value) || "Pacifico";
      var serif = "bold " + (P.Base_Height * PX) + "px Georgia, 'Times New Roman', serif";

      /* drop shadow, painted straight onto the main surface */
      ctx.save();
      ctx.translate(6, 8); ctx.globalAlpha = 0.15; ctx.fillStyle = "#000";
      ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.font = serif;
      ctx.lineJoin = "round"; ctx.lineCap = "round";
      ctx.lineWidth = P.Base_Rim_Width * 2 * PX;
      ctx.strokeText(initial, cx, cy); ctx.fillText(initial, cx, cy);
      ctx.restore();

      /* 1. base initial */
      layer(function (o, hex) {
        o.textAlign = "center"; o.textBaseline = "middle"; o.font = serif;
        o.lineJoin = "round"; o.lineCap = "round";
        o.fillStyle = hex; o.strokeStyle = hex;
        o.lineWidth = P.Base_Rim_Width * 2 * PX;
        o.strokeText(initial, cx, cy);
        o.fillText(initial, cx, cy);
      }, b.def, 7);

      function nameTransform(o) {
        o.translate(cx + P.Horizontal_Adj * PX, cy - P.Vertical_Adj * PX);
        o.rotate(-P.Rotation_Angle * Math.PI / 180);
        o.textAlign = "center"; o.textBaseline = "middle";
        o.font = (NAME_SIZE * PX) + 'px "' + font + '", cursive';
        if ("letterSpacing" in o) {
          o.letterSpacing = ((P.Letter_Spacing - 1) * NAME_SIZE * PX) + "px";
        }
        o.lineJoin = "round"; o.lineCap = "round";
      }

      /* 2. outline around the name */
      layer(function (o, hex) {
        o.save(); nameTransform(o);
        o.strokeStyle = hex; o.fillStyle = hex;
        o.lineWidth = P.Name_Total_Offset * 2 * PX;
        o.strokeText(nm, 0, 0); o.fillText(nm, 0, 0);
        o.restore();
      }, ou.def, 23);

      /* 3. the name itself */
      layer(function (o, hex) {
        o.save(); nameTransform(o);
        o.fillStyle = hex; o.fillText(nm, 0, 0);
        o.restore();
      }, co.def, 41);


      cap.textContent = nm + " — " + b.name + " initial, " + ou.name +
                        " outline, " + co.name + " name";

      var colors3d = { base: b.def, outline: ou.def, core: co.def };
      if (accentSlot && slots[accentSlot]) colors3d.accent = COLORS[slots[accentSlot].value] || null;
      update3d({ name: nm, font: font, colors: colors3d });
    }

    nameIn.addEventListener("input", function () { userHid = false; draw(); });
    if (fontIn) fontIn.addEventListener("change", draw);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(draw).catch(function () { draw(); });
    }
    draw();
  }

  function boot() {
    document.querySelectorAll(".jf-personalizer").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }
  document.addEventListener("shopify:section:load", boot);
})();